import { createRouter, createWebHistory } from "vue-router";
import defaultLayout from "./layouts/side-nav-outer-toolbar";
import simpleLayout from "./layouts/single-card";
import { useAuthStore } from "@/stores/auth";
import { useApiPing } from "./utils/apiClient";

function createDefaultView(path, name, component) {
  return {
    path: path,
    name: name,
    meta: {
      requiresAuth: true,
      layout: defaultLayout
    },
    component: () => import(`${component}`),
  };
}

const routes = [
  createDefaultView("/home", "Home", "./views/HomeView.vue"),
  createDefaultView("/register/maintenance", "Maintenance", "./views/register/MaintenanceView.vue"),
  createDefaultView("/register/maintenance/:id", "MaintenanceNew", "./views/register/MaintenanceView.vue"),
  createDefaultView("/register/maintenanceimport", "MaintenanceImport", "./views/register/MaintenanceImportView.vue"),
  createDefaultView("/register/maintenancecycle", "MaintenanceCycle", "./views/register/MaintenanceCycleView.vue"),
  createDefaultView("/register/maintenancecycle/:id", "MaintenanceCycleNew", "./views/register/MaintenanceCycleView.vue"),
  createDefaultView("/register/maintenancerequest", "MaintenanceRequest", "./views/register/MaintenanceRequestView.vue"),
  createDefaultView("/register/maintenancerequest/:id", "MaintenanceRequestNew", "./views/register/MaintenanceRequestView.vue"),
  createDefaultView("/register/maintenancelist", "MaintenanceList", "./views/register/MaintenanceListView.vue"),
  createDefaultView("/register/calllist", "CallRegister", "./views/register/CallListView.vue"),
  createDefaultView("/register/call", "CallNew", "./views/register/CallView.vue"),
  createDefaultView("/register/call/:id", "Call", "./views/register/CallView.vue"),
  createDefaultView("/register/serviceactlist", "ServiceActList", "./views/register/ServiceActListView.vue"),
  createDefaultView("/register/serviceact", "ServiceActNew", "./views/register/ServiceActView.vue"),
  createDefaultView("/register/serviceact/:id", "ServiceAct", "./views/register/ServiceActView.vue"),
  createDefaultView("/register/equipmentlist", "EquipmentList", "./views/register/EquipmentListView.vue"),
  createDefaultView("/register/equipment/:id", "Equipment", "./views/register/EquipmentView.vue"),
  createDefaultView("/register/equipment", "EquipmentNew", "./views/register/EquipmentView.vue"),
  createDefaultView("/register/equipmentimport", "EquipmentImport", "./views/register/EquipmentImportView.vue"),
  createDefaultView("/register/componentlist", "ComponentList", "./views/register/ComponentListView.vue"),
  createDefaultView("/register/component/:id", "Component", "./views/register/ComponentView.vue"),
  createDefaultView("/register/component", "ComponentNew", "./views/register/ComponentView.vue"),
  createDefaultView("/register/componentimport", "ComponentImport", "./views/register/ComponentImportView.vue"),
  createDefaultView("/register/projectlist", "ProjectList", "./views/register/ProjectListView.vue"),
  createDefaultView("/register/project", "ProjectNew", "./views/register/ProjectView.vue"),
  createDefaultView("/register/project/:id", "Project", "./views/register/ProjectView.vue"),
  createDefaultView("/classifier/equipmentmodellist", "EquipmentModelList", "./views/classifier/EquipmentModelListView.vue"),
  createDefaultView("/classifier/equipmentmodel/:id", "EquipmentModel", "./views/classifier/EquipmentModelView.vue"),
  createDefaultView("/classifier/equipmentmodel", "EquipmentModelNew", "./views/classifier/EquipmentModelView.vue"),
  createDefaultView("/classifier/equipmenttypelist", "EquipmentTypeList", "./views/classifier/EquipmentTypeListView.vue"),
  createDefaultView("/classifier/equipmenttype/:id", "EquipmentType", "./views/classifier/EquipmentTypeView.vue"),
  createDefaultView("/classifier/equipmenttype", "EquipmentTypeNew", "./views/classifier/EquipmentTypeView.vue"),
  createDefaultView("/classifier/equipmentcategorylist", "EquipmentCategoryList", "./views/classifier/EquipmentCategoryListView.vue"),
  createDefaultView("/classifier/equipmentcategory/:id", "EquipmentCategory", "./views/classifier/EquipmentCategoryView.vue"),
  createDefaultView("/classifier/equipmentcategory", "EquipmentCategoryNew", "./views/classifier/EquipmentCategoryView.vue"),
  createDefaultView("/classifier/manufacturerlist", "ManufacturerList", "./views/classifier/ManufacturerListView.vue"),
  createDefaultView("/classifier/manufacturer/:id", "Manufacturer", "./views/classifier/ManufacturerView.vue"),
  createDefaultView("/classifier/manufacturer", "ManufacturerNew", "./views/classifier/ManufacturerView.vue"),
  createDefaultView("/classifier/clientlist", "ClientList", "./views/classifier/ClientListView.vue"),
  createDefaultView("/classifier/client/:id", "Client", "./views/classifier/ClientView.vue"),
  createDefaultView("/classifier/client", "ClientNew", "./views/classifier/ClientView.vue"),
  createDefaultView("/classifier/enduserlist", "EndUserList", "./views/classifier/EndUserListView.vue"),
  createDefaultView("/classifier/enduser/:id", "EndUser", "./views/classifier/EndUserView.vue"),
  createDefaultView("/classifier/enduser", "EndUserNew", "./views/classifier/EndUserView.vue"),
  createDefaultView("/classifier/professionlist", "ProfessionList", "./views/classifier/ProfessionListView.vue"),
  createDefaultView("/classifier/profession/:id", "Profession", "./views/classifier/ProfessionView.vue"),
  createDefaultView("/classifier/profession", "ProfessionNew", "./views/classifier/ProfessionView.vue"),
  createDefaultView("/classifier/personlist", "PersonList", "./views/classifier/PersonListView.vue"),
  createDefaultView("/classifier/person/:id", "Person", "./views/classifier/PersonView.vue"),
  createDefaultView("/classifier/person", "PersonNew", "./views/classifier/PersonView.vue"),
  createDefaultView("/administration/administration", "Administration", "./views/administration/AdministrationView.vue"),
  createDefaultView("/administration/printformlist", "PrintFormList", "./views/administration/PrintFormListView.vue"),
  createDefaultView("/administration/printform/:code", "PrintForm", "./views/administration/PrintFormView.vue"),
  createDefaultView("/administration/reportlist", "ReportList", "./views/administration/ReportListView.vue"),
  createDefaultView("/administration/report/:id", "Report", "./views/administration/ReportView.vue"),
  createDefaultView("/administration/report", "ReportNew", "./views/administration/ReportView.vue"),
  createDefaultView("/administration/profile", "ProfileView", "./views/administration/ProfileView.vue"),
  {
    path: "/public/serviceact/approve/:url",
    name: "ServiceActApproval",
    meta: {
      requiresAuth: false,
      layout: defaultLayout
    },
    component: () => import("./views/public/ServiceActApprovalView.vue")
  },
  {
    path: "/login",
    name: "login",
    meta: {
      requiresAuth: false,
      layout: simpleLayout,
    },
    component: () => import("./views/LoginView.vue")
  },
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/home"
  }
];

const router = new createRouter({
  routes: routes,
  history: createWebHistory()
});

router.beforeEach(async (to, from, next) => {
  const auth = useAuthStore();
  const authRequired = to.matched.some(record => record.meta.requiresAuth);
  const api = useApiPing();

  if (!authRequired) {
    next();
    return;
  }

  if (to.name === "login"){
    if(auth.isAuthenticated()){
      next({ name: "Home" });
    }
  }else{
    api.ping(); // Check if can ping api host;
  }

  if(auth.user?.passwordChangeRequired === true && to.name !== "ProfileView"){
    next({ 
      name: "ProfileView",
      query: { required: "true" } 
    });
  }

  if (authRequired) {
    if (!auth.isAuthenticated()) {
      next({ name: "login", query: { redirect: to.fullPath }});
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
